import Vue from 'vue'
export default new Vue


// WEBPACK FOOTER //
// ./src/common/emit_on.js